module.exports = __webpack_public_path__ + "img/composer-reminder.d87878e5.svg";